import * as React from "react";

import { cn } from "@shared-utils/ui";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "focus-visible:outline-hidden flex min-h-[60px] w-full rounded-md shadow-xs border border-input bg-background px-3 py-2 text-[16px] md:text-sm placeholder:text-ter-gray-400 focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
